import seo1 from '../../assets/individualService/generalcontracting.jpeg';
import seo2 from '../../assets/individualService/const2.jpeg';
import webmig1 from '../../assets/individualService/General1.jpg';
import webmig2 from '../../assets/individualService/general2.jpeg';
import webmain from '../../assets/individualService/custom.jpeg';
import webmain2 from '../../assets/individualService/custom2.jpg';
import ecommerce from '../../assets/individualService/projectmanage.png';
import ecommerce2 from '../../assets/individualService/projectmanage2.jpg';
import cooperatewebsite from '../../assets/individualService/waste1.jpg';
import cooperate2 from '../../assets/individualService/waste2.jpg';
import ui from '../../assets/individualService/freight.jpeg';
import ux from '../../assets/individualService/freight2.jpg';

const data = [
  {
    id: 1,
    heading: 'Construction Management',
    content:
      'Construction management is the process of overseeing and managing construction projects from start to finish.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: seo1,
        content:
          'The construction manager is responsible for coordinating and managing the various aspects of a construction project, including planning, design, budgeting, scheduling, and execution. The role of the construction manager is to ensure that the project is completed within the given time frame, budget, and quality standards, while adhering to safety regulations and building codes.Construction management involves working with a team of professionals, including architects, engineers, contractors, subcontractors, and suppliers.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: seo2,
        content:
          "The construction manager acts as a liaison between the client and the project team, providing regular updates on the project's progress and ensuring that all parties are working towards the same goals. The construction manager is also responsible for identifying and mitigating any potential risks or issues that may arise during the project's execution, such as delays, budget overruns, or quality issues. With effective construction management, projects can be completed on time, within budget, and to the satisfaction of all stakeholders.",
      },
    ],
  },
  {
    id: 2,
    heading: 'General Contracting',
    content:
      'General contracting is a construction project delivery method in which a single entity, the general contractor, is responsible for the overall management and coordination of a construction project.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: webmig1,
        content:
          'The general contractor acts as the primary point of contact between the owner or client and the various subcontractors and vendors involved in the project.The general contractor is responsible for all aspects of the project, including hiring and managing subcontractors, procurement of materials and equipment, scheduling, budgeting, and quality control. They must ensure that the project is completed on time, within budget, and to the required quality standards.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: webmig2,
        content:
          'The general contractor typically takes on the financial risk of the project, as they are responsible for any cost overruns or delays. They also bear the responsibility for ensuring that the project complies with all building codes, safety regulations, and other legal requirements. With effective general contracting, clients can be assured that their construction project will be completed to their satisfaction, with minimal disruption and hassle.',
      },
    ],
  },
  {
    id: 3,
    heading: 'The collection and transportation of waste',
    content:
      'The collection and transportation of waste is a crucial component of waste management. ',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: cooperatewebsite,
        content:
          'The collection of waste involves the use of specialized vehicles and equipment, such as garbage trucks and waste containers. Waste collectors follow scheduled routes to collect waste from designated areas, such as residential neighborhoods, public parks, and commercial areas.Once the waste has been collected, it is transported to a disposal site, such as a landfill or recycling center. The transportation of waste involves ensuring that the waste is safely and efficiently transported to the disposal site, while adhering to strict safety regulations and environmental standards.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: cooperate2,
        content:
          'Effective collection and transportation of waste are critical for maintaining a clean and healthy environment, reducing the risk of pollution, and promoting sustainable waste management practices. It requires a coordinated effort between waste management companies, local authorities, and the general public to ensure that waste is disposed of safely and responsibly.',
      },
    ],
  },
  {
    id: 4,
    heading: 'Project management',
    content:
      'Project management is the process of planning, organizing, and managing resources to achieve specific goals and objectives within a defined timeline and budget.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: ecommerce,
        content:
          "It involves the application of knowledge, skills, tools, and techniques to ensure that project deliverables meet the requirements and expectations of stakeholders.The project management process typically involves five stages: initiation, planning, execution, monitoring and controlling, and project closure. During the initiation stage, the project manager defines the project scope, objectives, and stakeholders. In the planning stage, the project manager develops a detailed project plan, including timelines, budgets, and resource allocation.The execution stage involves the implementation of the project plan, including the coordination of tasks, team management, and communication with stakeholders. During the monitoring and controlling stage, the project manager tracks the project's progress and makes any necessary adjustments to ensure that the project stays on track.",
      },
      {
        heading: 'Get The Maximum Benefits',
        img: ecommerce2,
        content:
          ' Finally, the project closure stage involves the completion of the project, including finalizing project deliverables, documentation, and conducting a project evaluation.Effective project management is essential for ensuring that projects are completed on time, within budget, and to the satisfaction of stakeholders. It requires strong leadership, communication, and problem-solving skills, as well as the ability to manage risks and adapt to changing circumstances. With effective project management, organizations can achieve their strategic objectives and maximize their return on investment..',
      },
    ],
  },
  {
    id: 5,
    heading: 'Customs clearance',
    content:
      'Customs clearance refers to the process of clearing goods through customs to facilitate the movement of goods across international borders.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: webmain,
        content:
          'This process involves compliance with import and export regulations, payment of duties and taxes, and obtaining the necessary documentation to legally import or export goods.Customs clearance is typically handled by customs brokers or freight forwarders, who are responsible for ensuring that all necessary paperwork is in order, and that goods are properly classified and valued. They work closely with customs officials to ensure that all customs regulations and requirements are met, and that goods are cleared for entry into the destination country.. ',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: webmain2,
        content:
          'Customs clearance can be a complex and time-consuming process, particularly for businesses that are not familiar with the customs regulations of the destination country. Failure to comply with customs regulations can result in costly delays, fines, and even seizure of goods.Effective customs clearance requires knowledge of international trade laws and regulations, as well as strong relationships with customs officials and other relevant agencies. With proper planning and preparation, customs clearance can be streamlined, allowing for the smooth and efficient movement of goods across international borders..',
      },
    ],
  },
  {
    id: 6,
    heading: 'Freight forwarding ',
    content:
      'Freight forwarding is the process of coordinating and managing the transportation of goods from one location to another.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: ui,
        content:
          'Freight forwarders act as intermediaries between shippers and carriers, providing a range of services to ensure that goods are transported efficiently and cost-effectively.Freight forwarding services typically include arranging transportation, negotiating rates with carriers, handling documentation, and providing tracking and logistics support. Freight forwarders work closely with shippers to understand their specific transportation needs and develop customized solutions that meet their requirements.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: ux,
        content:
          'Freight forwarding involves managing various modes of transportation, including air, sea, and land transport. Freight forwarders must have knowledge of transportation regulations and requirements, as well as expertise in navigating customs procedures and dealing with potential issues that may arise during transport, such as delays or damages.Effective freight forwarding requires strong communication skills, attention to detail, and the ability to manage multiple tasks and deadlines. With proper planning and execution, freight forwarding can help businesses reduce transportation costs, improve supply chain efficiency, and ensure that goods are delivered on time and in good condition.',
      },
    ],
  },
  {
    id: 7,
    heading: 'SEOy Service',
    content:
      'Search Engine optimization startegies and tactics will increase organic search visibility on Google, generating leads, sales and revenue.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: seo1,
        content:
          'Desktop computers have better processors, and they often have more reliable connection speeds to the internet than mobile devices on a carrier’s data network. This means that loading sites on mobile devices is often slightly slower than on a desktop—even if the site is optimized for mobile.Page speed (or your website loading speed) is a major aspect of mobile search engine optimization (SEO). Web performance impacts not only search rankings but also your user mobile experience. Optimizing page speed for mobile involves addressing round trip requests, render-blocking, lazy-loading, compression, caching, and the Accelerated Mobile Page HTML (AMP-HTML) code options.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: seo2,
        content:
          'Google’s mobile guidelines don’t have specific details about page speed or mobile speed, but it’s still important for mobile SEO for several reasons. Google has a limited amount of time that it spends crawling each site, and making sites load faster encourages Google to crawl more pages. This means that improving your site speed can promote faster discovery and indexing of new pages and new content, as well as a comprehensive crawling of deeper pages in the site. Even if your rank stays the same on a page-by-page basis, the total number of pages that have the ability to rank increases, often impacting overall organic traffic, especially for long-tail terms.',
      },
    ],
  },
  {
    id: 8,
    heading: 'Web migration services',
    content:
      "Our team of web developers experts focus on migrating websites in an SEO friendly fashion, ensuring that your website doesn't lose organic visiblity and ranking .",
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: webmig1,
        content:
          'Website migrations come in all shapes and sizes. Our team of website migration experts tailor solutions directly to your exact needs. We’ve handled hundreds of website migrations since 2005 and have continued to refine our processes as new technologies and digital trends advance.Whether you are looking for onsite SEO optimizations, comprehensive URL redirect mapping, content analysis, or post-migration support and solutions, Marcel Digital has you covered.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: webmig2,
        content:
          'CenturyByte Digital is a team of digital marketing, web development, Google Analytics, paid media, and usability experts who believe in the interconnectivity of digital efforts. We believe that all of these disciplines work together to execute successful website migrations. Every employee at CenturyByte Digital is Google Analytics and Google Tag Manager Certified, renewing their certification every year. We also staff a full team of seasoned website developers knowledgeable on many different types of technologies and platforms, ensuring that we bring expertise and personalized solutions to your specific setup.',
      },
    ],
  },
  {
    id: 9,
    heading: 'Corporate Web Design',
    content:
      'We will analyze the product and the market to determine the best strategy for your product.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: cooperatewebsite,
        content:
          'Corporate web design is the process of designing and developing a business website to serve as a pillar of a company’s online presence.Not to be mistaken for a promotional website, the focus of a corporate website is to promote an entire company rather than focus on a single product or sub-brand.While promotional websites are focused on specific products or services, a corporate website does not promote, advertise or market products, but instead emphasizes business performance, corporate news, staff and social responsibility.The main purpose of corporate web design is to reflect the company’s success, fortify its reputation, build trust and inform about services and products ― but not focus on them',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: cooperate2,
        content:
          'Corporate web design is the process of designing and developing a business website to serve as a pillar of a company’s online presence.Not to be mistaken for a promotional website, the focus of a corporate website is to promote an entire company rather than focus on a single product or sub-brand.While promotional websites are focused on specific products or services, a corporate website does not promote, advertise or market products, but instead emphasizes business performance, corporate news, staff and social responsibility.The main purpose of corporate web design is to reflect the company’s success, fortify its reputation, build trust and inform about services and products ― but not focus on them',
      },
    ],
  },
  {
    id: 10,
    heading: 'E-Commerce System',
    content:
      'Our business transactions occur either as business-to-business (B2B), business-to-consumer (B2C), consumer-to-consumer or consumer-to-business.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: ecommerce,
        content:
          'Business-to-business (B2B) e-commerce refers to the electronic exchange of products, services or information between businesses rather than between businesses and consumers. Examples include online directories and product and supply exchange websites that let businesses search for products, services and information and initiate transactions through e-procurement interfaces. A Forrester report published in 2018 predicted that by 2023, B2B e-commerce will reach $1.8 trillion dollars and account for 17% of U.S. B2B sales.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: ecommerce2,
        content:
          'Business-to-consumer (B2C) is the retail part of e-commerce on the internet. It is when businesses sell products, services or information directly to consumers. The term was popular during the dot-com boom of the late 1990s, when online retailers and sellers of goods were a novelty.Today, there are innumerable virtual stores and malls on the internet selling all types of consumer goods. Amazon is the most recognized example of these sites. It dominates the B2C market.',
      },
    ],
  },
  {
    id: 11,
    heading: 'Web Maintenance Service',
    content:
      'Our teams maintains and manage websites. This implies that the site is accessible and that it functions smoothly that the content is current and the site itself is further developed to keep the old and bring new ones.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: webmain,
        content:
          'Maintenance is important for the viewing, usefulness and security of your website. Maintaining and updating web pages is a serious job that we approach professionally as well as its creation of websites. Maintaining websites implies maintaining a high level of security of your website, making a backup of the database and / or the entire contents of your site, taking care of all installed applications, administering e-mail addresses, hosting and user domains. In addition, advanced maintenance or running your site can include SEO optimization as well as web marketing and writing original content. ',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: webmain2,
        content:
          'Your website fulfills its role only if all information is current and if the pages contain correct and valid data. Updating consists of modifying, adding or deleting content, adding a description of new services, references, new photos of your products, changing contact details, prices and actions. If changes in your website are relatively frequent, you do not want to deal with them on your own and you would like us to take care of the entire engagement on the Internet, we will do a professional job for you.',
      },
    ],
  },
  {
    id: 12,
    heading: 'UI/UX Design',
    content:
      'User experience encompasses all aspects of the end-user’s interaction with the company, its services, and its products.',
    contents: [
      {
        heading: 'Get The Maximum Benefits',
        img: ui,
        content:
          'A user interface is the point of interaction between the user and a digital device or product—like the touchscreen on your smartphone, or the touchpad you use to select what kind of coffee you want from the coffee machine.In relation to websites and apps, UI design considers the look, feel, and interactivity of the product. It’s all about making sure that the user interface of a product is as intuitive as possible, and that means carefully considering each and every visual, interactive element the user might encounter.',
      },
      {
        heading: 'Get The Maximum Benefits',
        img: ux,
        content:
          'User Experience (UX) and User Interface (UI) are some of the most confused and misused terms in our field. A UI without UX is like a painter slapping paint onto a canvas without thought; while UX without UI is like the frame of a sculpture with no paper mache on it. A great product experience starts with UX followed by UI. Both are essential for the product’s success',
      },
    ],
  },
];

export default data;
